import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from "react";
import { Button, Modal, CentreContents } from "../index";
import { capitaliseFirstLetter } from "../general/utils";
function OrgChart(props) {
    const { title, data, modalKeys, boxKeys, subtitle, bordered = false, toggleButton = true, } = props;
    const orgChartSize = () => {
        if (data.length <= 2) {
            return "xs";
        }
        else if (data.length <= 4) {
            return "sm";
        }
        else if (data.length <= 6) {
            return "md";
        }
        else if (data.length <= 8) {
            return "lg";
        }
        else {
            return "xl";
        }
    };
    const hiddenByDefault = !toggleButton
        ? false
        : (props.hiddenByDefault ?? true);
    const [isCollapsed, setIsCollapsed] = useState(hiddenByDefault);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };
    const handleModalOpen = (dataPoint) => {
        if (modalKeys) {
            setModalData(Object.fromEntries(modalKeys.map((key) => [key, dataPoint[key]])));
            setModalOpen(true);
        }
    };
    const modalHeader = (modalTitle) => {
        return (_jsx("h4", { className: "tol-org-chart-modal-header", children: modalTitle ?? "Details:" }));
    };
    const modalBody = (_jsx("div", { children: modalData &&
            modalKeys
                ?.filter((key) => key !== "title")
                .map((key, index) => (_jsxs("div", { className: "tol-org-chart-modal-row", children: [_jsx("strong", { children: `${modalData[key] && capitaliseFirstLetter(key) + ": "}` }), modalData[key] ?? ""] }, index))) }));
    const detailModal = (_jsx(Modal, { open: modalOpen, setOpen: setModalOpen, size: "sm", header: modalHeader(modalData?.title), children: modalBody }));
    return (_jsx(CentreContents, { children: _jsxs("div", { className: `tol-org-chart ${props.className} ${orgChartSize()}`, children: [detailModal, _jsxs("div", { className: `tol-org-chart-title ${toggleButton ? "button" : ""}`, onClick: () => toggleCollapse(), children: [title, toggleButton && (_jsx(Button, { onClick: () => toggleCollapse(), className: "tol-org-chart-show-hide-button", icon: !isCollapsed ? "chevron-up" : "chevron-down", tooltip: !isCollapsed ? "Hide" : "Show" }))] }), _jsx("div", { children: subtitle && !isCollapsed && (_jsx("div", { className: "tol-org-chart-subtitle", children: subtitle })) }), _jsxs("div", { className: `tol-org-chart-content-container ${isCollapsed ? "collapsed" : ""}`, children: [_jsx("div", { className: "tol-org-chart-line-vertical" }), _jsx("div", { className: "tol-org-chart-connector" }), _jsx("div", { className: "tol-org-chart-data", children: data.map((dataPoint, index) => (_jsxs("div", { onClick: () => handleModalOpen(dataPoint), children: [_jsx("div", { className: "tol-org-chart-connector-vertical" }), _jsxs("div", { className: `tol-org-chart-box ${bordered ? "bordered" : ""}`, children: [_jsx("div", { className: "tol-org-chart-box-title", children: dataPoint.title }), boxKeys &&
                                                boxKeys
                                                    ?.filter((key) => key !== "title")
                                                    .map((key, index) => {
                                                    return (_jsx("div", { className: "tol-org-chart-box-body", children: dataPoint[key] }, index));
                                                })] })] }, index))) })] })] }) }));
}
export default OrgChart;
